import type { ConfirmDialogProps } from '@/components/feedback/ConfirmDialog';
import { ConfirmDialog } from '@/components/feedback/ConfirmDialog';
import { graphql, type DocumentType } from '@/gql';
import { useMutation } from '@/hooks/mutationWithSnackbar';

import { ASSISTANT_RECENT_CONVERSATIONS_QUERY } from '../AssistantRecentConversations';

const DELETE_CONVERSATION_MUTATION = graphql(`
  mutation DeleteConversation($params: DeleteConversationInput) {
    deleteConversation(params: $params) {
      success
    }
  }
`);

const ASSISTANT_DELETE_CONVERSATION_DIALOG_CONVERSATION_FRAGMENT = graphql(`
  fragment assistantDeleteConversationDialogConversationFields on OrtooGptConversation {
    _id
    caption
  }
`);

interface Props extends Omit<ConfirmDialogProps, 'onConfirm'> {
  conversation: DocumentType<
    typeof ASSISTANT_DELETE_CONVERSATION_DIALOG_CONVERSATION_FRAGMENT
  >;
}

export const AssistantDeleteConversationDialog = ({
  conversation,
  onClose,
  ...other
}: Props) => {
  const [deleteConversation, { loading }] = useMutation(
    DELETE_CONVERSATION_MUTATION,
    {
      completionMessage: 'Conversation deleted',
      refetchQueries: [ASSISTANT_RECENT_CONVERSATIONS_QUERY],
      awaitRefetchQueries: true,
      onCompleted: onClose,
    },
  );

  return (
    <>
      <ConfirmDialog
        {...other}
        ariaLabel="ai-assistant-delete-conversation"
        titleText={`Are you sure you want to delete the conversation called "${conversation.caption}"?`}
        innerText={`Clicking delete will delete this conversation and all of its messages, this change cannot be reverted.`}
        confirmButtonProps={{ color: 'error' }}
        confirmText="Delete"
        loading={loading}
        onConfirm={() => {
          deleteConversation({
            variables: {
              params: { conversation: conversation._id },
            },
          });
        }}
        onClose={onClose}
      />
    </>
  );
};
